<template>
  <v-card outlined rounded="lg" class="pa-4" elevation="0">
    <v-row class="ma-0" dense v-if="!isResult">
      <v-col class="text-center" cols="12">
        <span>{{ $t('Período') }}</span>
        <div class="d-flex justify-center align-center mt-3">
          <v-menu
            ref="startDateMenu"
            :close-on-content-click="false"
            :return-value.sync="startDate"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                :disabled="isResult"
                append-icon="mdi-calendar"
                class="primary-button"
                style="text-transform: none"
                readonly
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(startDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="startDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="
                $refs.startDateMenu.save(startDate),
                  (filterProp.data = null),
                  list()
              "
            >
            </v-date-picker>
          </v-menu>

          <span class="mx-2">{{ $t('Até') }}</span>

          <v-menu
            ref="endDateMenu"
            :close-on-content-click="false"
            :return-value.sync="endDate"
            transition="scale-transition"
            @change="list"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                :disabled="isResult"
                append-icon="mdi-calendar"
                class="primary-button"
                style="text-transform: none"
                readonly
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(endDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="endDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="
                $refs.endDateMenu.save(endDate),
                  (filterProp.data = null),
                  list()
              "
            >
            </v-date-picker>
          </v-menu>
        </div>
      </v-col>
    </v-row>

    <v-alert
      type="warning"
      class="my-3 pa-1 text-center"
      v-if="costs.length == 0"
    >
      {{ $t('Nenhum dado encontrado') }}
    </v-alert>

    <div v-else>
      <v-row class="ma-0" justify="center">
        <v-col cols="12">
          <strong class="ma-2">
            Total:
            {{ total ? total.toInstLocale() : '0,00' }}
          </strong>

          <div>
            <div class="hidden-md-and-up">
              <v-data-table
                :loading="loading"
                :headers="headerMobile"
                :items="costs"
                class="main-table"
                :hide-default-footer="!filterProp.data"
                show-expand
                item-key="costId"
                :single-expand="false"
                :items-per-page="7"
                :header-props="headerProps"
                :mobile-breakpoint="0"
                :expanded.sync="expanded"
                @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
              >
                <template v-slot:[`item.os`]="{ item }">
                  {{ item.serviceOrderNumber }}
                </template>

                <template v-slot:[`item.valor`]="{ item }">
                  {{ item.costValue }}
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>O.S Tipo:</strong>
                        {{ serviceOrderTypes[item.serviceOrderType] }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>Nº Identificação:</strong>
                        {{ item.identification }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>Equipamento:</strong>
                        {{ item.equipmentName }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>Descrição:</strong>
                        {{ item.costDescription }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>Fornecedor:</strong>
                        {{ item.costSupplier }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>Nº Nota:</strong>
                        {{ item.costInvoice }}
                      </p>
                    </v-col>
                  </td>
                </template>
              </v-data-table>
              <div class="pagination" v-if="!filterProp.data">
                <div class="item-pagination block-two">
                  <v-pagination
                    class="pagination-item"
                    v-model="page"
                    :length="totalPages"
                    :total-visible="3"
                  ></v-pagination>
                </div>
              </div>
            </div>

            <div class="hidden-md-and-down">
              <v-data-table
                :loading="loading"
                :headers="header"
                :items="costs"
                class="main-table"
                :hide-default-footer="!filterProp.data"
                hide-default-header
                :header-props="headerProps"
                :items-per-page="7"
              >
                <template #header="{ props, on }">
                  <thead>
                    <tr>
                      <th
                        class="text-center"
                        v-for="header in props.headers"
                        :key="header.value"
                      >
                        <v-simple-checkbox
                          v-if="header.value === 'data-table-select'"
                          v-model="props.everyItem"
                          :indeterminate="props.someItems && !props.everyItem"
                          color="purple"
                          @input="on['toggle-select-all']"
                        ></v-simple-checkbox>

                        <div>
                          <v-hover v-slot="{ hover }">
                            <div>
                              <span>{{ $t(header.text) }}</span>
                              <v-icon
                                v-if="
                                  hover &&
                                  header.value != 'data-table-select' &&
                                  header.value != 'actions'
                                "
                                color="white"
                                class="mx-2"
                                @click="on.sort(header.value)"
                              >
                                {{
                                  props.options.sortBy.includes(header.value)
                                    ? `mdi-chevron-down`
                                    : `mdi-chevron-up`
                                }}
                              </v-icon>
                            </div>
                          </v-hover>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </template>

                <template v-slot:[`item.os`]="{ item }">
                  {{ item.serviceOrderNumber }}
                </template>

                <template v-slot:[`item.OSTipo`]="{ item }">
                  {{ serviceOrderTypes[item.serviceOrderType] }}
                </template>

                <template v-slot:[`item.numIdent`]="{ item }">
                  {{ item.identification }}
                </template>

                <template v-slot:[`item.equipamento`]="{ item }">
                  {{ item.equipmentName }}
                </template>

                <template v-slot:[`item.descricao`]="{ item }">
                  {{ item.costDescription }}
                </template>
                <template v-slot:[`item.fornecedor`]="{ item }">
                  {{ item.costSupplier }}
                </template>
                <template v-slot:[`item.numNota`]="{ item }">
                  {{ item.costInvoice }}
                </template>
                <template v-slot:[`item.valor`]="{ item }">
                  {{ item.costValueDouble.toInstLocale() }}
                </template>
              </v-data-table>
              <div class="pagination" v-if="!filterProp.data">
                <div class="item-pagination block-two">
                  <v-pagination
                    class="pagination-item"
                    v-model="page"
                    :length="totalPages"
                    :total-visible="3"
                  ></v-pagination>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-row class="ma-0">
      <v-col cols="12" v-if="isResult">
        <strong>{{ $t('Análise crítica') }}</strong>
        <p v-html="review"></p>
      </v-col>
      <v-col cols="12" v-else>
        <tiptap-vuetify
          v-model="filter.review"
          :extensions="extensions"
          :label="$t('Análise crítica')"
          :placeholder="
            $t('Digite sua análise crítica para o indicador abaixo')
          "
          :card-props="{ flat: true, outlined: true, rounded: true }"
          class="primary-input"
          outlined
          dense
          hide-details="auto"
        ></tiptap-vuetify>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../../../services/ApiService'
import Utils from '../../../../../../../../Utils/FormatDate'
import moment from 'moment'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

export default {
  props: {
    filterProp: Object,
    institution: Object,
    unidades: Array,
    isResult: { type: Boolean, default: false },
    review: String,
  },

  components: {
    TiptapVuetify,
  },

  data() {
    return {
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      filter: {
        page: 1,
        pageSize: 7,
        institutionId: null,
        unidadeIds: [],
        startDate: null,
        endDate: null,
        review: '',
      },
      apiService: new ApiService(),
      loading: false,
      page: 1,
      showChart: true,
      totalPages: 1,
      pageSize: 7,
      costs: [],
      expanded: [],
      serviceOrderTypes: [
        'Treinamento',
        'Segurança elétrica',
        'Preventiva',
        'Instalação',
        'Rotina de Inspeção',
        'Corretiva',
        'Calibração',
        'Validação/Qualificação',
        'Serviço Administrativo',
        'Empréstimo',
      ],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'O.S.',
          align: 'center',
          value: 'os',
          sortable: false,
        },
        {
          text: 'Tipo O.S.',
          align: 'center',
          value: 'OSTipo',
          sortable: false,
        },
        {
          text: 'Nº Identificação',
          align: 'center',
          value: 'numIdent',
          sortable: false,
        },
        {
          text: 'Equipamento',
          align: 'center',
          value: 'equipamento',
          sortable: false,
        },
        {
          text: 'Descrição',
          align: 'center',
          value: 'descricao',
          sortable: false,
        },
        {
          text: 'Fornecedor',
          align: 'center',
          value: 'fornecedor',
          sortable: false,
        },
        {
          text: 'Nº Nota',
          align: 'center',
          value: 'numNota',
          sortable: false,
        },
        {
          text: 'Valor',
          align: 'center',
          value: 'valor',
        },
      ],
      headerMobile: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'O.S',
          align: 'center',
          value: 'os',
          sortable: false,
        },
        {
          text: 'Valor',
          align: 'center',
          value: 'valor',
          sortable: false,
        },
      ],
      total: 0,
      startDate: '',
      endDate: '',
    }
  },

  async created() {
    this.filter.institutionId = this.institution.id
    this.filter.unidadeIds = this.unidades

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    if (this.filterProp) {
      this.filter = this.filterProp
      this.startDate = moment(this.filter.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.endDate = moment(this.filter.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    }

    this.list()
  },

  methods: {
    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    setInfos() {
      const model = {
        chart: '3.1 - Custos por peça avulsa',
        ...this.filter,
        data: null,
      }
      this.$emit('setInfos', model)
    },
    formatDate(date) {
      return Utils.dateTime(date)
    },

    async list() {
      if (this.filterProp.data) {
        const response = JSON.parse(this.filterProp.data)
        this.total = response.content.total
        this.costs = []
        this.showChart = response.content.model.objects.length > 0
        this.costs = response.content.model.objects
        this.totalPages = response.content.model.pager.totalPages
        return
      }

      this.setDates()
      this.filter.institutionId = this.institution.id
      this.filter.pageSize = 7
      this.filter.unidadeIds = this.unidades
      await this.apiService
        .post('reports/listCostsSinglePiece', this.filter)
        .then((response) => {
          this.total = response.content.total
          this.costs = []
          this.showChart = response.content.model.objects.length > 0
          this.costs = response.content.model.objects
          this.totalPages = response.content.model.pager.totalPages
        })
        .catch(() => {})
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },

    filter: {
      deep: true,
      handler() {
        this.setInfos()
      },
    },
  },
}
</script>
